import React from 'react'
import {useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'


const headCells = [
  { id: 'title', align: 'left', disablePadding: false},
  { id: 'courseName', align: 'left', disablePadding: false},
  { id: 'type', align: 'left', disablePadding: false},
  { id: 'unitName', align: 'left', disablePadding: false},
  { id: 'repository', align: 'left', disablePadding: false}
];

const useStyles = makeStyles((theme) => ({
  headersRow: {
    color: '#50566e',
    '& > th': {
      borderTop: 'solid 1px #becfd7',
      backgroundColor: '#ffffff'
    }
  },
  headerLabel: {
    color: '#4f576e',
    fontWeight: 500
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}))


export default function AssessmentBankHead({context}) {

  const classes = useStyles()
  const history = useHistory()
  const {query, translate, navigate} = context
  const order = query.orderBy ? (query.orderBy.startsWith('-') ? 'desc' : 'asc') : undefined
  const orderBy = order ? (order == 'asc' ? query.orderBy : query.orderBy.substring(1)) : undefined

  const createSortHandler = (property) => (event) => {
    navigate(undefined, undefined, {query: {
      ...query,
      page: 1,
      orderBy: `${orderBy == property && order == 'asc' ? '-' : ''}${property}`
    }})
  }

  return (
    <TableHead>
      <TableRow className={classes.headersRow}>
          {headCells.map(({id, align, disablePadding}) => (
          <TableCell
            key={id}
            align = {align}
            padding={disablePadding ? 'none' : 'normal'}
            sortDirection={order}
            style={{top:92}}
          >
            <TableSortLabel
              className={classes.headerLabel}
              active={orderBy === id}
              direction={order}
              onClick={createSortHandler(id)}
            >
              {translate(`${id}-header`)}
              {orderBy === id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell className={classes.actions} style={{top:92}} />
      </TableRow>
    </TableHead>
  )
}
